import { createSelector } from 'reselect'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.INTERACTIVE_VIDEO_LIVE_STUDENT_PACED_MODE,
])

const settingsSelector = state => state.interactiveVideo.settings

export default createSelector(
	[settingsSelector, featureFlagsSelector],
	(settings, featureFlags) => ({
		isInteractiveMode: settings.isInteractiveMode,
		shouldHideStudentNames: settings.shouldHideStudentNames,
		streamMode: settings.streamMode,
		isUsingNewStreamModeModal: featureFlags[featureFlagsTypes.INTERACTIVE_VIDEO_LIVE_STUDENT_PACED_MODE],
	})
)
